export default "__VITE_ASSET__BCnQk5z7__$_?url__"